"use client";
import React, { Fragment, useState } from "react";
import {
  Dialog,
  DialogPanel,
  Transition,
  TransitionChild,
} from "@headlessui/react";
import {
  Bars2Icon,
  ArrowLeftStartOnRectangleIcon,
} from "@heroicons/react/24/outline";
import { signOut } from "next-auth/react";
import MenuList from "./menu";
import MenuLogo from "./logo";
import { usePathname } from "next/navigation";
import { useStoreContext } from "@/lib/store";
import ContactCenti from "@/app/(procure)/procure/dashboard/_components/ContactCenti";

export const MobileLayout = ({
  profile,
  cart,
}: {
  profile: React.ReactNode[];
  cart: React.ReactNode;
}) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const pathname = usePathname();
  const { user } = useStoreContext();
  const background =
    "rounded-lg bg-white shadow-sm ring-1 ring-zinc-950/5 dark:bg-zinc-900 dark:ring-white/10";

  return (
    <>
      {/* Mobile Header */}
      <div className="lg:hidden shadow bg-white z-[11] sticky top-0">
        <div className="py-3 px-5 flex justify-between items-center">
          <MenuLogo link />
          <div className="flex justify-end items-center space-x-1">
            {/* { profile[1] } */}
            {pathname.includes("procure") && cart}
            <button
              type="button"
              className="lg:hidden -m-2.5 p-2.5 text-gray-700"
              onClick={() => setSidebarOpen(true)}>
              <Bars2Icon className="size-7 text-dark" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Sidebar */}
      <Transition show={sidebarOpen} as={Fragment}>
        <Dialog
          as="div"
          className="lg:hidden relative z-50"
          onClose={() => setSidebarOpen(false)}>
          <TransitionChild
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0">
            <div className="fixed inset-0 bg-black/30" />
          </TransitionChild>
          <div className="fixed inset-0 flex">
            <TransitionChild
              as={Fragment}
              enter="ease-in-out duration-300"
              enterFrom="-translate-x-full"
              enterTo="translate-x-0"
              leave="ease-in-out duration-300"
              leaveFrom="translate-x-0"
              leaveTo="-translate-x-full">
              <DialogPanel className="transition inset-y-0 p-2 relative mr-16 flex w-full max-w-xs flex-1">
                <div
                  className={`flex grow flex-col gap-y-2 overflow-y-auto ${background}`}>
                  <div className="px-6 py-4">
                    <MenuLogo />
                  </div>
                  <MenuList />
                  <div className="px-5">
                    <ContactCenti variant="mobile" />
                  </div>
                  {user && user?.id && (
                    <div className="px-4 py-4">{profile[0]}</div>
                  )}
                </div>
              </DialogPanel>
            </TransitionChild>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export const SignOut = () => {
  return (
    <ArrowLeftStartOnRectangleIcon
      className="size-6 md:size-5 text-zinc-400 hover:text-primary hover:cursor-pointer"
      onClick={() =>
        signOut({
          redirectTo: "/login",
          redirect: true,
        })
      }
    />
  );
};
